// extracted by mini-css-extract-plugin
export default {"topMainDiv":"HeaderTopDiv_topMainDiv__N6jZI","topMidDiv":"HeaderTopDiv_topMidDiv__8Q4ea","socialLink":"HeaderTopDiv_socialLink__a9EPs"};